export default "__VITE_ASSET__DQenf1Es__"